import axios, { type AxiosError } from 'axios'
import { useAuthStore } from '../stores/authStore'

/**
 * Client Axios condiviso. Aggiunge automaticamente:
 *  - JWT Bearer dal localStorage (se presente)
 *  - intercettore 401 → logout + redirect
 *
 * Le richieste passano dal proxy Vite (porta 5173) che inoltra ai prefissi
 * di backend (vedi vite.config.ts) verso localhost:3000.
 */
export const api = axios.create({
  baseURL: '/',
  timeout: 30_000,
})

api.interceptors.request.use((config) => {
  const token = useAuthStore.getState().token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

api.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    if (err.response?.status === 401) {
      const { token, esci } = useAuthStore.getState()
      if (token) {
        esci()
        // Reload soft per riportare alla pagina di login
        if (window.location.pathname !== '/accedi') {
          window.location.href = '/accedi'
        }
      }
    }
    return Promise.reject(err)
  },
)

/** Estrae il messaggio di errore dal payload backend RingCoach. */
export function messaggioErrore(err: unknown): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as { errore?: string } | undefined
    return data?.errore ?? err.message ?? 'Errore di rete'
  }
  if (err instanceof Error) return err.message
  return 'Errore sconosciuto'
}
